<template>
    <div>
        <v-container justify-start>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex shrink>
                    <div class="title mb-2 mr-2">New Match</div>
                </v-flex>
                <v-divider vertical class="hidden-xs-only mr-2"></v-divider>
                <v-flex align-self-start>
                    <v-breadcrumbs divider=">" style="display:inline; padding-left: 0;">
                        <v-breadcrumbs-item style to="/admin" v-bind:exact="exact">Administration</v-breadcrumbs-item>
                        <v-breadcrumbs-item style to="/admin/matches" v-bind:exact="exact">Matches</v-breadcrumbs-item>
                        <v-breadcrumbs-item style to="/admin/matches/new" v-bind:exact="exact">New Match</v-breadcrumbs-item>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
        </v-container>
        <v-container grid-list-md>
            <v-layout row wrap justify-start>
                <v-flex xs12 sm6>
                    <v-card>
                        <v-card-text>
                            <v-form ref="form" v-model="valid">
                                <v-select
                                    v-model="seasonId"
                                    v-bind:items="seasons"
                                    label="Season"
                                    required
                                ></v-select>
                                <v-select
                                    v-model="awayTeamId"
                                    v-bind:items="teams"
                                    label="Away Team"
                                    v-bind:rules="teamRules"
                                    required
                                ></v-select>
                                <v-select
                                    v-model="homeTeamId"
                                    v-bind:items="teams"
                                    label="Home Team"
                                    v-bind:rules="teamRules"
                                    required
                                ></v-select>
                                <v-date-picker
                                    v-model="datePicker"
                                    color="grey darken-2"
                                    reactive="reactive"
                                    class="mb-4"
                                    full-width
                                ></v-date-picker>
                                <v-time-picker
                                    v-model="timePicker"
                                    color="grey darken-2"
                                    class="mb-4"
                                    full-width
                                ></v-time-picker>
                                <v-text-field label="Duration (min)" v-model="duration" mask="###"></v-text-field>
                                <v-select
                                    v-model="locationId"
                                    v-bind:items="locations"
                                    label="Location"
                                ></v-select>
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn
                                flat
                                color="primary"
                                v-bind:disabled="!valid"
                                v-on:keyup.enter="submit"
                                v-on:click="submit"
                                data-cy="signinSubmitBtn"
                            >Create Match</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'AdminMatchesNew',
    data() {
        return {
            exact: true,
            valid: false,
            seasonId: '',
            awayTeamId: '',
            homeTeamId: '',
            datePicker: this.$moment()
                .add(1, 'day')
                .format('YYYY-MM-DD'),
            timePicker: '20:30',
            duration: 105,
            locationId: '',
            teamRules: [
                // Verify teams are not already playing at this time.
                () => {
                    if (this.awayTeamId === this.homeTeamId && this.awayTeamId && this.homeTeamId) {
                        return 'Away and home teams must be different.'
                    } else {
                        return true
                    }
                }
            ]
        }
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('createMatch', {
                    away_team_id: this.awayTeamId,
                    away_team_score: -1,
                    home_team_id: this.homeTeamId,
                    home_team_score: -1,
                    duration: this.duration,
                    match_datetime: this.$moment(`${this.datePicker} ${this.timePicker}`).toDate(),
                    season_id: this.seasonId,
                    location_id: this.locationId
                })
            }
        }
    },
    computed: {
        seasons() {
            return this.$store.state.seasons
                .map((season) => {
                    return { text: season.season, value: season.id }
                })
                .sort((a, b) => {
                    if (a.text > b.text) {
                        return -1
                    } else if (a.text < b.text) {
                        return 1
                    } else {
                        return 0
                    }
                })
        },
        teams() {
            let teams = this.$store.getters.getTeamsSortedByName
            let teamsDropdown = []

            teams.forEach((team) => {
                teamsDropdown.push({ text: team.team, value: team.id })
            })

            return teamsDropdown
        },
        locations() {
            let locations = this.$store.getters.getLocationsSorted
            let locationsDropdown = []

            locations.forEach((location) => {
                locationsDropdown.push({ text: location.location, value: location.id })
            })

            return locationsDropdown
        }
    },
    mounted() {
        if (this.$store.state.currentSeason) {
            this.seasonId = this.$store.state.currentSeason.id
        }
    }
}
</script>

<style scoped>
</style>
